import ForgotPassword from '../../modules/auth/UI/ForgotPassword';

function ForgotPasswordPage() {
  return <ForgotPassword />;
}

export default ForgotPasswordPage;
